<template>
    <v-card variant="flat" class="overflow-visible">
        <travel-card-details
            :id="id"
            v-model:is-blocked="isTravelCardBlocked"
            :name="name"
            :status="status"
            :number="number"
            :card-type="cardType"
            :pending-products="pendingProducts"
            :products="products"
            :auto-travel-product="autoTravelProduct"
            :travel-money-amount="travelMoneyAmount"
            :pending-travel-money="pendingTravelMoney"
        />
    </v-card>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { TravelCardDto } from '../../types';
import { TravelCardStatus } from '../../constants';
import TravelCardDetails from './TravelCardDetails.vue';

const props = defineProps<TravelCardDto & { cardType: number }>();

const isTravelCardBlocked = ref(props.status === TravelCardStatus.Blocked);
</script>
